import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { IOnboardingModule } from '../ui/components/lc-tour/lc-tour-provider'
import { OnboardingData } from '../ui/components/lc-tour/components/StartOnboarding'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export interface PropsReset {
  steps: number
  stepIndex?: number
  key: string
  statusReset: boolean
}

type ModuleFilter = Record<string, string | number | boolean | undefined>

interface SaveProgressBody {
  moduleProgress: string
  stepIndex: number
}

interface NoteRememberBody {
  notRemember: boolean
}

export const onboardingApi = createApi({
  reducerPath: 'OnboardingApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/Onboarding`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),

  endpoints: (builder) => ({
    getProgressOnboarding: builder.mutation<OnboardingData[], any>({
      query: () => ({
        url: '/progress',
        method: 'GET',
      }),
    }),
    getModuleOnboarding: builder.mutation<IOnboardingModule[], ModuleFilter>({
      query: (keyModules) => ({
        url: '/modules',
        method: 'GET',
        params: keyModules,
      }),
    }),

    postProgressOnboarding: builder.mutation<OnboardingData[], SaveProgressBody>({
      query: (body) => ({
        url: '/progress',
        method: 'post',
        body: { ...body },
      }),
    }),
    postProgressOnboardingNotRemember: builder.mutation<OnboardingData[], NoteRememberBody>({
      query: (body) => ({
        url: '/notRemember',
        method: 'post',
        body: { ...body },
      }),
    }),
    getMockDataOnboarding: builder.mutation<any[], any>({
      query: () => ({
        url: '/mockData',
        method: 'GET',
      }),
    }),
    postResetDataModules: builder.mutation<OnboardingData[], PropsReset[]>({
      query: (resetModules) => ({
        url: '/resetModule',
        method: 'POST',
        body: { resetData: resetModules },
      }),
    }),
  }),
})

export const {
  useGetModuleOnboardingMutation,
  useGetProgressOnboardingMutation,
  usePostProgressOnboardingMutation,
  usePostProgressOnboardingNotRememberMutation,
  useGetMockDataOnboardingMutation,
  usePostResetDataModulesMutation,
} = onboardingApi
